import { render, staticRenderFns } from "./HandMoneyIcon.vue?vue&type=template&id=04555c74&"
import script from "./HandMoneyIcon.vue?vue&type=script&lang=js&"
export * from "./HandMoneyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports